import React, { useEffect, useState } from "react";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import api from "../api";
import TermsPrivacyHelper from "../components/TermsPrivacyHelper";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export default function TermsPrivacy(props) {
  const classes = useStyles();
  const { cId, mode } = props;
  const [data, setData] = useState({ sections: [] });
  const [backdropOpen, setBackdropOpen] = React.useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (cId !== undefined) {
        setBackdropOpen(true);
        try {
          const terms = await api.center.get(cId, mode);
          setData(terms.data);
        } catch (ex) {
        } finally {
          setBackdropOpen(false);
        }
      }
    };
    fetchData();
  }, [cId, mode]);

  return (
    <div className="container text-left">
      <div className="your-class mt-3"></div>
      <TermsPrivacyHelper data={data} />

      <Backdrop className={classes.backdrop} open={backdropOpen}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}

// export default TermsPrivacy;
